<mat-card class="email-verification-card">
  <h2>Verify recovery email</h2>
  <p>Recovery by email is available after you verify the address.</p>

  <form (ngSubmit)="sendCode()">
    <mat-form-field appearance="standard" class="email-field">
      <mat-label>Email address</mat-label>
      <input matInput type="email" autocomplete="email" [formControl]="email" [readonly]="codeRequested">
      <mat-error *ngIf="email.hasError('required')">Enter an email address.</mat-error>
      <mat-error *ngIf="email.hasError('email')">Enter a valid email address.</mat-error>
      <mat-error *ngIf="email.hasError('maxlength')">Email address is too long.</mat-error>
    </mat-form-field>
    <button mat-flat-button type="submit" [disabled]="!email.valid || sending || cooldownSeconds > 0">
      <span *ngIf="cooldownSeconds === 0">{{codeRequested ? 'Resend code' : 'Send email code'}}</span>
      <span *ngIf="cooldownSeconds > 0">Try again in {{cooldownSeconds}}s</span>
    </button>
  </form>

  <form *ngIf="codeRequested" (ngSubmit)="confirmCode()">
    <mat-form-field appearance="standard" class="email-field">
      <mat-label>Email verification code</mat-label>
      <input matInput inputmode="numeric" autocomplete="one-time-code" maxlength="6" [formControl]="emailCode">
      <mat-error *ngIf="emailCode.invalid">Enter the 6-digit code from the email.</mat-error>
    </mat-form-field>
    <button mat-flat-button type="submit" color="primary" [disabled]="!emailCode.valid || confirming">
      Verify email
    </button>
  </form>

  <p class="message" *ngIf="message">{{message}}</p>
  <p class="error" *ngIf="errorMessage" role="alert">{{errorMessage}}</p>

  <div class="actions">
    <button *ngIf="showLater" mat-button type="button" (click)="continueLater()">Later</button>
    <button *ngIf="!showLater" mat-button type="button" (click)="cancelFlow()">Cancel</button>
  </div>
</mat-card>
